// extracted by mini-css-extract-plugin
export default {"container":"Stat_container__KZf7d","main":"Stat_main__XgSkA"};